module.exports = __webpack_public_path__ + "img/btnStatus6.d02efcc1.png";